import { Fragment } from "react";

const ITEMS = [
  { t: "Unapologetically immaculate", s: false },
  { t: "No dust left alive", s: true },
  { t: "Homes & headquarters", s: false },
  { t: "Filthy? Not on our watch", s: true },
  { t: "White-glove rebels", s: false },
];

const Star = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-7 w-7 shrink-0 sm:mx-12 sm:h-9 sm:w-9" aria-hidden="true">
    <path d="M12 0c.8 6.4 5.6 11.2 12 12-6.4.8-11.2 5.6-12 12-.8-6.4-5.6-11.2-12-12 6.4-.8 11.2-5.6 12-12z" fill="#EDB89E" />
  </svg>
);

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((it) => (
      <Fragment key={it.t}>
        <span className={it.s ? "font-serif-i text-5xl text-zinc-100 sm:text-7xl" : "stroke-text font-display text-5xl uppercase sm:text-7xl"}>
          {it.t}
        </span>
        <Star />
      </Fragment>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-white/10 bg-[#0D0E11] py-8 sm:py-10" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max whitespace-nowrap">
      <Row />
      <Row />
    </div>
  </section>
);
